<label
  [for]="uid"
  class="inline-flex items-center cursor-pointer"
  [class.flex-row-reverse]="labelPosition() === 'before'"
  [class.cursor-not-allowed]="isDisabled() || disabled()"
  [class.opacity-60]="isDisabled() || disabled()"
>
  <input
    [id]="uid"
    type="checkbox"
    role="switch"
    [attr.aria-checked]="value() || checked()"
    [checked]="value() || checked()"
    [disabled]="isDisabled() || disabled()"
    (change)="onToggle($event)"
    class="sr-only peer disabled:cursor-not-allowed"
  />
  <div [class]="trackClass()"></div>
  <span
    class="ms-3 text-sm font-medium text-fg"
    [class.text-red-500]="hasError()"
  >
    <ng-content />
  </span>
</label>
